import React from 'react';
import { useDispatch } from 'react-redux';
import Icon, { COLORS, ICONS } from '../../general-components/icon';
import { setSolutionCenterContentState } from '../../../stores/actions/user-interface';
import {
	HomeSectionContainer,
	HomeSectionHeader,
	ProductsList,
	ProductsListItem,
	ProductsListItemText,
	RecentActivityIconLink,
	SolutionCenterUl,
	SearchItem,
	SearchItemSnippet,
	Shadow,
	RecentActivityText,
} from '../elements';
import {
	RECENT_ACTIVITY_ITEMS,
	RecentActivityTypes,
	SolutionCenterContentTypes,
	ZendeskCategory,
} from '../../../types/solution-center';

interface HomeViewProps {
	categories: ZendeskCategory[];
	handleSelectCategory: (categoryId: number) => void;
}

export default function HomeView(props: HomeViewProps) {
	const dispatch = useDispatch();

	const {
		categories,
		handleSelectCategory,
	} = props;

	const handleItemOnClick = (id: number, type: RecentActivityTypes) => {
		if (type === RecentActivityTypes.Article || type === RecentActivityTypes.Post) {
			dispatch(setSolutionCenterContentState({
				id,
				type: type === RecentActivityTypes.Article
					? SolutionCenterContentTypes.Article
					: SolutionCenterContentTypes.Post,
			}));
		} else if (type === RecentActivityTypes.Category) {
			handleSelectCategory(id);
		}
	};

	return (
		<>
			<HomeSectionContainer>
				<HomeSectionHeader>Products</HomeSectionHeader>
				<ProductsList>
					{/* Show the first 5 categories */}
					{categories.filter((c) => c.position < 5).map((category) => (
						<ProductsListItem key={`category-${category.id}`}>
							<ProductsListItemText onClick={() => handleSelectCategory(category.id)}>
								{category.name}
							</ProductsListItemText>
						</ProductsListItem>
					))}
				</ProductsList>
			</HomeSectionContainer>
			<HomeSectionContainer>
				<HomeSectionHeader>Recent Activity</HomeSectionHeader>
				<SolutionCenterUl>
					{RECENT_ACTIVITY_ITEMS.map((item) => (
						<SearchItem key={`recent-activity-${item.id}`} className="recent-activity">
							<div>
								<RecentActivityText onClick={() => handleItemOnClick(item.id, item.type)}>
									{item.title}&nbsp;
								</RecentActivityText>
								<RecentActivityIconLink
									href={item.url}
									target="_blank"
									rel="noopener noreferrer"
								>
									<Icon name={ICONS.EXPAND} size={16} color={COLORS.PALE_GREEN} />
								</RecentActivityIconLink>
							</div>
							<SearchItemSnippet>{item.snippet}</SearchItemSnippet>
						</SearchItem>
					))}
				</SolutionCenterUl>
			</HomeSectionContainer>
			<Shadow />
		</>
	);
}
